<template>
  <div class="section-card">
    <div class="section-header">
      <p class="section-title">Your Responses</p>
    </div>
    <v-divider></v-divider>
    <div class="response-list">
      <div v-for="(item, index) in items" :key="index" class="response-row">
        <p class="response-label">{{ index + 1 }}. {{ item.label }}</p>
        <p class="response-value">&nbsp; {{ item.value }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type ResponseItem = {
  label: string;
  value: string;
};

withDefaults(
  defineProps<{
    items?: ResponseItem[];
  }>(),
  {
    items: () => [],
  },
);
</script>

<style scoped>
.section-card {
  background: #fff;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-color);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.section-title {
  margin: 0;
  font-size: var(--font-size-default);
  letter-spacing: 0.1em;
  text-transform: capitalize;
  color: var(--color-title);
  font-weight: 700;
}

.response-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.response-row {
  border-bottom: 1px solid #eef2f7;
  padding-bottom: 10px;
}

.response-row:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.response-label {
  margin: 0;
  font-size: var(--font-size-default);
  color: var(--color-title);
  font-weight: 600;
}

.response-value {
  margin: 4px 0 0 2px;
  font-size: var(--font-size-default);
  color: var(--color-title);

}
</style>
